import styled from 'styled-components';

const StyledForm = styled.form`
  &&& {
    height: 100%;
    margin: 0px;
    display: flex;
    flex-direction: column;
  }
`;

const StyledFormContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  height: 532px;
  overflow-y: auto;
`;

const SubmitButtons = styled.div`
  display: flex;

  input {
    text-align: center;
    width: 100%;
    margin-bottom: 1em;
  }
`;

const NameLabel = styled.label`
  width: 50%;
  font-weight: 700;
  margin-top: 1em;
`;

const NameInput = styled.input`
  height: 50px;
`;

const Select = styled.select`
  height: 50px;
`;

const ActionResourceRow = styled.div`
  display: flex;
  width: 100%;
  p {
    flex: 1;
  }
  &&& a {
    width: 10%;
    font-size: 2em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const FormRow = styled.div`
  display: flex;
  width: 100%;

  label {
    font-weight: 700;
  }

  .goalIconSelect {
    width: 50%;
  }

  > * {
    &:not(:first-of-type) {
      margin-left: 0.5em;
    }
  }
`;

const StyledFileInput = styled.div`
  width: 50%;
  margin-top: 1em;
  margin-right: 0.5em;
  > div {
    margin-bottom: 0;
    margin-top: 8px;
    border: 1px solid #e5e9eb;
    border-radius: 5px;
    height: 50px;
    background: white;
    span {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
`;

const DescriptionLabel = styled.label`
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  font-weight: 700;
  min-height: 155px;
  max-height: 400px;
`;

const DescriptionTextArea = styled.textarea`
  &&& {
    display: flex;
    flex: 1;
    margin-bottom: 3em;
  }
`;

const StyledFooterLink = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  &&& a {
    text-transform: lowercase;
  }
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

const MarkdownTextArea = styled.div`
  font-weight: normal;
`;

const StyledUSPLabel = styled.div`
  display: flex;
  select {
    margin-right: 1em;
  }
`;

const StyleQuestionRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
  p {
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 5px;
  }
`;

const StyledUPSQuestions = styled.div`
  padding: 0 1em;
  display: flex;
  flex-direction: column;

  h4 {
    margin-top: 0;
  }

  &&& button {
    height: 40px;
    width: 150px;
  }
`;
export {
  StyledUPSQuestions,
  StyleQuestionRow,
  StyledUSPLabel,
  StyledForm,
  StyledFormContainer,
  SubmitButtons,
  NameLabel,
  Select,
  ActionResourceRow,
  FormRow,
  NameInput,
  MarkdownTextArea,
  DescriptionLabel,
  DescriptionTextArea,
  StyledFooterLink,
  FooterRow,
  StyledFileInput,
};
